import DigitizationContentComponent from "./editorDigitizationContent/DigitizationContentComponent";
import "../editorStyleSheet.css"
import BodyComponents from "./BodyComponents";
import PropTypes from "prop-types";
import {regenerateAudioPerPage, rerunService, updatePagesDataByArticleId} from "../../../axios-client";
import {useEffect, useState} from "react";
import DigitizationMarkdownComponent from "./editorDigitizationContent/DigitizationMarkdownComponent";
import DigitizationHtmlComponent from "./editorDigitizationContent/DigitizationHtmlComponent";
import DigitizationTextComponent from "./editorDigitizationContent/DigitizationTextComponent";
import DigitizationHtmlBlocksComponent from "./editorDigitizationContent/DigitizationHtmlBlocksComponent";
import { useTranslation } from "react-i18next";

const EditorBodyComponent = ({
    handleFullScreen,
    isFullScreen,
    mediaPath,
    pdfUrl,
    containerWidth,
    forcePageNumber,
    numPages,
    pageNumber,
    setForcePageNumber,
    configWidth,
    updateConfigWidth,
    page,
    pages,
    fileName,
    sourceLanguage,
    targetLanguage,
    articleId,
    digitizationId,
    setNotification,
    setPage,
    bookmarkingSelected,
    translationSelected,
    diacriticsSelected,
    setUpdatePages,
    isStructured,
    usedOcr,
    updatedPages,
    sidenavOpen,
    fetchData,
    digitizationDataPath
}) => {
    const [zoom, setZoom] = useState(0.3);
    const [isProcessing, setIsProcessing] = useState(false)
    const { t } = useTranslation(['editor']);

    const [selectedWordBbox, setSelectedWordBbox] = useState(
        [{
            lineIndex: 0,
            wordIndex: 0,
            word: {}
        }])
    const [pdfDimensions, setPdfDimensions] = useState({width: 0, height: 0});

    const [hoveredChunkId, setHoveredChunkId] = useState(null);

    useEffect(() => {
        setSelectedWordBbox([{
            lineIndex: 0,
            wordIndex: 0,
            word: {}
        }])
    }, [page]);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (updatedPages?.length > 0) {
                const message = "You have unsaved changes, are you sure you want to leave?";
                e.returnValue = message;
                return message;
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [updatedPages]);

    const addOrUpdatePages = (num, data , field) => {

        setUpdatePages(prevTexts => {
            const existingText = prevTexts.find(item => item.num === num);

            if (existingText) {
                return prevTexts.map(item =>
                    item.num === num ? { ...item, [field]: data } : item
                );
            } else {
                return [...prevTexts, { num, [field]: data }];
            }
        });
    };

    const updateAudioPaths = (audioList) => {
        const matchingAudio = audioList.find(audio => audio.num === page.num);
        const existingPage = updatedPages.find(item => item.num === page.num);

        setPage({
            ...page,
            markdown: existingPage.markdown ?? page.markdown,
            vertices: existingPage.vertices ?? page.vertices,
            translated_text: existingPage.translated_text ?? page.translated_text,
            audio_path: matchingAudio.audio_path
        })
    };
    const regenerateBookmarking = () => {
        rerunService(digitizationId, {service_name: 'Bookmarking'})
            .then(() => {
                setNotification({ show: true, snackbarMessage: 'Regenerating Bookmarking in progress', severity: 'success' });
            })
            .catch(e => {
                setNotification({ show: true, snackbarMessage: 'An unexpected error occurred', severity: 'error' });
            })
    }
    const regenerateAudio = (articleId) => {
        setIsProcessing(true)
        regenerateAudioPerPage(articleId, [{'page_num': page.num}])
            .then((res) => {

                if (res && res.data) {
                    updateAudioPaths(res.data)
                }
                setNotification({ show: true, snackbarMessage: t('updatedAudio'), severity: 'success' });
                setIsProcessing(false)

            })
            .catch(e => {
                setNotification({ show: true, snackbarMessage: t('updateError'), severity: 'error' });
                setIsProcessing(false)
            })
    }
      
    const updatePages = () => {
        return updatePagesDataByArticleId(articleId, updatedPages)
            .then((res) => {
                if (res.data && res.data.updated_pages) {
                    updateAudioPaths(res.data.updated_pages)
                }
                setUpdatePages([])
                setNotification({ show: true, snackbarMessage: 'Pages updated successfully.', severity: 'success' });
            })
            .catch((error) => {
                setNotification({ show: true, snackbarMessage: 'An unexpected error occurred', severity: 'error' });
            });
    };

    

    return (
        <div className="digitizationEditorBody">
            <div className="body-component">
                <BodyComponents
                    mediaPath={mediaPath}
                    pdfUrl={pdfUrl}
                    numPages={numPages}
                    pages={pages}
                    forcePageNumber={forcePageNumber}
                    pageNumber={pageNumber}
                    setForcePageNumber={setForcePageNumber}
                    containerWidth={containerWidth}
                    configWidth={configWidth}
                    handleFullScreen={handleFullScreen}
                    isFullScreen={isFullScreen}
                    setNotification={setNotification}
                    articleId={articleId}
                    zoom={zoom}
                    setZoom={setZoom}
                    selectedWordBbox={selectedWordBbox}
                    setSelectedWordBbox={setSelectedWordBbox}
                    pdfDimensions={pdfDimensions}
                    addOrUpdatePages={addOrUpdatePages}
                    setHoveredChunkId={setHoveredChunkId}
                    hoveredChunkId={hoveredChunkId}
                    page={page}
                />

                {(usedOcr == 'Balanced' || usedOcr == 'Premium') ? <DigitizationMarkdownComponent
                    pageNumber={pageNumber}
                    configWidth={configWidth}
                    containerWidth={containerWidth}
                    updateConfigWidth={updateConfigWidth}
                    page={page}
                    numPages={numPages}
                    digitizationId={digitizationId}
                    sourceLanguage={sourceLanguage}
                    targetLanguage={targetLanguage}
                    addOrUpdatePages={addOrUpdatePages}
                    updatedPages={updatedPages}
                    handleSave={updatePages}
                    translationSelected={translationSelected}
                    diacriticsSelected={diacriticsSelected}
                    fileName={fileName}
                    fetchData={fetchData}
                    articleId={articleId}
                    /> :

                    usedOcr == 'Fast' ?

                        <DigitizationContentComponent
                            pageNumber={pageNumber}
                            configWidth={configWidth}
                            containerWidth={containerWidth}
                            updateConfigWidth={updateConfigWidth}
                            page={page}
                            numPages={numPages}
                            digitizationId={digitizationId}
                            sourceLanguage={sourceLanguage}
                            targetLanguage={targetLanguage}
                            addOrUpdatePages={addOrUpdatePages}
                            updatedPages={updatedPages}
                            handleSave={updatePages}
                            translationSelected={translationSelected}
                            diacriticsSelected={diacriticsSelected}
                            setSelectedWordBbox={setSelectedWordBbox}
                            selectedWordBbox={selectedWordBbox}
                            setPdfDimensions={setPdfDimensions}
                            setPage={setPage}
                            fileName={fileName}
                            fetchData={fetchData}
                            articleId={articleId}
                        /> : 
                        
                        usedOcr == 'Advanced' ?

                        <DigitizationHtmlComponent
                            pageNumber={pageNumber}
                            configWidth={configWidth}
                            containerWidth={containerWidth}
                            updateConfigWidth={updateConfigWidth}
                            page={page}
                            numPages={numPages}
                            digitizationId={digitizationId}
                            sourceLanguage={sourceLanguage}
                            targetLanguage={targetLanguage}
                            addOrUpdatePages={addOrUpdatePages}
                            updatedPages={updatedPages}
                            handleSave={updatePages}
                            translationSelected={translationSelected}
                            diacriticsSelected={diacriticsSelected}
                            fileName={fileName}
                            fetchData={fetchData}
                            digitizationDataPath={digitizationDataPath}
                            setPage={setPage}
                            setNotification={setNotification}                            
                    /> :

                        usedOcr == 'Agentic' ?

                        <DigitizationHtmlBlocksComponent
                            pageNumber={pageNumber}
                            configWidth={configWidth}
                            containerWidth={containerWidth}
                            updateConfigWidth={updateConfigWidth}
                            page={page}
                            setPage={setPage}                            
                            numPages={numPages}
                            digitizationId={digitizationId}
                            sourceLanguage={sourceLanguage}
                            targetLanguage={targetLanguage}
                            addOrUpdatePages={addOrUpdatePages}
                            updatedPages={updatedPages}
                            handleSave={updatePages}
                            translationSelected={translationSelected}
                            diacriticsSelected={diacriticsSelected}
                            setPdfDimensions={setPdfDimensions}
                            fileName={fileName}
                            fetchData={fetchData}
                            digitizationDataPath={digitizationDataPath}
                            setNotification={setNotification}
                            setHoveredChunkId={setHoveredChunkId}
                            hoveredChunkId={hoveredChunkId}
                        /> :

                        <DigitizationTextComponent
                            pageNumber={pageNumber}
                            configWidth={configWidth}
                            containerWidth={containerWidth}
                            updateConfigWidth={updateConfigWidth}
                            page={page}
                            numPages={numPages}
                            digitizationId={digitizationId}
                            sourceLanguage={sourceLanguage}
                            targetLanguage={targetLanguage}
                            addOrUpdatePages={addOrUpdatePages}
                            updatedPages={updatedPages}
                            handleSave={updatePages}
                            translationSelected={translationSelected}
                            diacriticsSelected={diacriticsSelected}
                            setSelectedWordBbox={setSelectedWordBbox}
                            selectedWordBbox={selectedWordBbox}
                            setPdfDimensions={setPdfDimensions}
                            setPage={setPage}
                            fileName={fileName}
                            fetchData={fetchData}
                            articleId={articleId}
                        />
                }
            </div>
        </div>
    )

}


EditorBodyComponent.propTypes = {
    mediaPath: PropTypes.string,
    digitizationDataPath: PropTypes.string,
    pdfUrl: PropTypes.string,
    containerWidth: PropTypes.string,
    configWidth: PropTypes.string,
    numPages: PropTypes.number,
    pageNumber: PropTypes.number,
    articleId: PropTypes.number,
    digitizationId: PropTypes.number,
    forcePageNumber: PropTypes.number,
    setForcePageNumber: PropTypes.func,
    updateConfigWidth: PropTypes.func,
    sourceLanguage: PropTypes.string,
    targetLanguage: PropTypes.string,
    page: PropTypes.object,
    pages: PropTypes.array,
    updatedPages: PropTypes.array,
    setPage: PropTypes.func,
    handleFullScreen: PropTypes.func,
    setNotification: PropTypes.func,
    setUpdatePages: PropTypes.func,
    isFullScreen: PropTypes.bool,
    isStructured: PropTypes.bool,
    bookmarkingSelected: PropTypes.bool,
    translationSelected: PropTypes.bool,
    diacriticsSelected: PropTypes.bool,
    sidenavOpen: PropTypes.bool,
    fileName: PropTypes.string,
    fetchData: PropTypes.func,
    usedOcr: PropTypes.string
};
export default EditorBodyComponent;